module.exports = __webpack_public_path__ + "static/img/makehole1.8da3e507.png";